"use strict";

import helpers from "./_helpers";
import Keyboard from 'simple-keyboard';

const Forms = () => {
    const init = () => {
        $(document).ready(function () {

            // Enable niceselect on nice-selected dropdowns
            $('.nice-select:not(.pyht-select)').niceSelect();
            $('.search-select').searchSelect();
            // Enable focus states
            $(document).on('click.nice_select', function(event) {
                $('.nice-select').parents('.form-group').removeClass('focused');

                if ($(event.target).closest('.nice-select').length !== 0) {
                    $(event.target).closest('.nice-select').parents('.form-group').addClass('focused');
                }
            });
            $(document).on('click.search_select', function(event) {
                $('.search-select').parents('.form-group').removeClass('focused');

                if ($(event.target).closest('.search-select').length !== 0) {
                    $(event.target).closest('.search-select').parents('.form-group').addClass('focused');
                }
            });
            // Refreshonselect
            $('.refreshonselect').on('change', function () {
                $(this).parents('form').find('.current-page').val(1);
                $('.nice-select').niceSelect('destroy');
                $('.search-select').searchSelect('destroy');
                $(this).parents('form').find('.ajax-submit').trigger('click');
                $('.nice-select').niceSelect();
                $('.search-select').searchSelect();
            });
            // Close nice select on click
            $('.nice-select:not(.bb-select) ul li').click(function () {
                setTimeout(function () {
                    $('.nice-select').removeClass("open");
                }, 10);
            });

            $("input[type='date']").parent().addClass('date-field');
            /**
             * Handle input focus to animate labels
             */
            $(document).on('focus','input, textarea', function (e) {
                $(this).parents('.form-group').addClass('focused');
            });

            $(document).on('blur','input, textarea, select', function (e) {
                var inputValue = $(this).val();
                if (inputValue == "") {
                    $(this).parents('.form-group').removeClass('filled');
                    $(this).parents('.form-group').removeClass('focused');
                } else {
                    $(this).parents('.form-group').addClass('filled');
                }
            });

            $(document).on('change','select', function (e) {
                var inputValue = $(this).val();
                if (inputValue == "") {
                    $(this).parents('.form-group').removeClass('filled');
                } else {
                    $(this).parents('.form-group').addClass('filled');
                }
            });

            $(window).on('resize', function(e) {
                $('select').each(function(){
                    var inputValue = $(this).val();
                    if (inputValue == "") {
                        $(this).parents('.form-group').removeClass('filled');
                    } else {
                        $(this).parents('.form-group').addClass('filled');
                    }
                });
            });

            $('input, textarea').on('animationstart webkitAnimationStart oAnimationStart MSAnimationStart', function(){
                var inputValue = $(this).val();
                if (inputValue == "") {
                    $(this).parents('.form-group').removeClass('filled');
                    $(this).parents('.form-group').removeClass('focused');
                } else {
                    $(this).parents('.form-group').addClass('filled');
                }
            })

            $('input, textarea').on('animationstart webkitAnimationStart oAnimationStart MSAnimationStart', function(){
                var inputValue = $(this).val();
                if (inputValue == "") {
                    $(this).parents('.form-group').removeClass('filled');
                    $(this).parents('.form-group').removeClass('focused');
                } else {
                    $(this).parents('.form-group').addClass('filled');
                }
            })

            $('.nice-select').on('animationstart webkitAnimationStart oAnimationStart MSAnimationStart', function(){
                $(this).niceSelect('update');
            })

            // Make all 'disabled' values actually disabled - not available in form builder
            $("option:selected").each(function () {
                let $option = $(this);
                if ($option.val() === 'disabled') {
                    $option.attr('disabled', true);
                    $option.attr('selected', true);
                }
            });

            // Add '*' to required fields
            $('input:required, select:required, textarea:required').each(function () {
                let $label = $(this).parents('.form-group').find('label');
                $label.addClass('required');
            });

            $('form input, form textarea').on('focus', function() {
                $(this).parents('.form-group').addClass('focused');
            });

            var loadedRecaptcha = false;
            window.addEventListener('scroll', loadRecaptcha, {passive:true});
            function loadRecaptcha(){
                let scroll = window.scrollY;
                if (scroll > 0 && !loadedRecaptcha) {
                    var recaptchaScript = document.createElement('script');
                    recaptchaScript.src = 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit';
                    recaptchaScript.defer = true;
                    document.body.appendChild(recaptchaScript);
                    loadedRecaptcha = true;
                    window.removeEventListener('scroll', loadRecaptcha, {passive:true});
                    console.log('loaded Recaptcha')
                }
            }

            $('.js-prefill-form').each(function(){
                var $form = $(this);
                if($form.data('prefill') !== undefined){
                    var data = $form.data('prefill');
                    $.each(data, function(key, value){
                        if(value instanceof Object){
                            $.each(value, function(k, v){
                                $form.find('[name="'+key+'-'+k+'"]').val(v);
                            });
                        }else{
                            $form.find('[name="'+key+'"]').val(value);
                        }
                    });
                }

                if($form.data('consultant-options') !== undefined){
                    var consultants = $form.data('consultant-options');
                    $.each(consultants, function(key, value){
                        $form.find('[name="consultant"]').append('<option value="'+value['email']+'">'+value['name']+'</option>');
                    });
                    $form.find('[name="consultant"]').niceSelect('update');
                }
            });

            $('form .ajax-submit').on('click', function(){
                if($(this).parents('form').find('[name="page"]').length){
                    var page = $(this).parents('form').find('[name="page"]').val();
                    helpers.setUrlParameter('page', page);
                }
            });

            $('form input[type="file"]').on('change', function(){
                var file_data = $(this).prop('files')[0];   
                var form_data = new FormData($(this).parents('form')[0]);                  
                form_data.append('file', file_data);                            
                $.ajax({
                    url: '/displayForm/onUpdateFile',
                    dataType: 'text',
                    cache: false,
                    contentType: false,
                    processData: false,
                    data: form_data,                         
                    type: 'post',
                    success: function(php_script_response){
                        console.log(php_script_response);
                    }, error: function(error){
                        console.log(error);
                    }
                });
            });

            if($('.simple-keyboard').length){
                const keyboard = new Keyboard({
                    onChange: input => onChange(input)
                });

                function onChange(input){
                    $('.keyboard-input').val(input);
                }

                $('body:not(.layout-pyht) input:not([type="checkbox"]), body:not(.layout-pyht) textarea').on('focus', function(){
                    $('.simple-keyboard').addClass('active');
                    $('.keyboard-input').removeClass('keyboard-input');
                    $('.focused').removeClass('focused');
                    $(this).addClass('keyboard-input');
                    $(this).parents('.form-group').addClass('focused');
                    keyboard.setInput($(this).val());
                });

                document.addEventListener("click", (event) => {
                    var $target = $(event.target);
                    if (
                        !$target.hasClass('simple-keyboard') 
                        && !$target.parents('.simple-keyboard').length
                        && !$target.is('textarea')
                        && !$target.is('input:not([type="checkbox"])')
                    ) {
                        $('.focused').removeClass('focused');
                        $('.keyboard-input').removeClass('keyboard-input');
                        $('.simple-keyboard').removeClass('active');
                    }
                });
            }
        });
        //////////////////////////////////////////////
        // Paginate Hook
        //////////////////////////////////////////////
        // Listen for ajax success events & jump the page to the results
        $(document).ajaxSuccess(function (xhr) {
            if (typeof xhr.target.nodeName !== 'undefined' && xhr.target.nodeName === 'FORM') {
                if ($("#results").length > 0) {
                    if($(window).scrollTop() > 0) {
                        $('html, body').animate({
                            scrollTop: $("#results").offset().top
                        }, 100);
                    }
                    paginateHook();
                }
                onSuccess(xhr.target);
            }
        });
        $(document).ajaxError(function (xhr) {
            if (typeof xhr.target.nodeName !== 'undefined' && xhr.target.nodeName === 'FORM') {
                if ($("#results").length > 0) {
                    if($(window).scrollTop() > 0) {
                        $('html, body').animate({
                            scrollTop: $("#results").offset().top
                        }, 100);
                    }
                    paginateHook();
                }
                onError(xhr.target);
            }
        });
        function getParam(name, url) {
            if (!url)
                url = location.href;
            name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
            var regexS = "[\\?&]" + name + "=([^&#]*)";
            var regex = new RegExp(regexS);
            var results = regex.exec(url);
            return results === null ? null : results[1];
        }
        function paginateHook() {
            $('.pagination a').on('click', function (e) {
                e.preventDefault();
                var page = getParam('page', $(this).attr('href'));
                var form = $(this).parents('[data-form]').data('form');

                $(form).find('.current-page').val(page);
                $(form).find('.ajax-submit').trigger('click');
            });
        }

        // Checkbox auto refresh
        $('.filter-container input[type=checkbox]').on('change', function() {
            $(this).parents('form').find('.current-page').val(1);
            $(this).parents('form').find('.ajax-submit').trigger('click');
        });

        paginateHook();
    };

    const onSuccess = (form) => {
        $(form).find('.alert-success').addClass('show');
        $(form).find('.alert-danger').removeClass('show');
        if($(window).scrollTop() > 0) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(form).offset().top
            }, 200);
        }
    };

    const onError = (form) => {
        $(form).find('.alert-danger').addClass('show');
        $(form).find('.alert-success').removeClass('show');
        if($(window).scrollTop() > 0) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $(form).offset().top
            }, 200);
        }
    };

    return {
        init: init,
        onSuccess: onSuccess,
        onError: onError
    };
};

export default Forms;